export default __webpack_public_path__ + "static/media/2_Credit_Check_Icon.b0815112.svg";